import ProductCard from './module.product-card.js'

export default class ProductGrid extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.endlessScroll = new Ajaxinate({
            container: '#product-gird-loop',
            pagination: '#infinite-Pagination',
            callback: () => {

              const loadedPage = document.querySelector('product-grid').getAttribute('data-page');
              document.querySelector('product-grid').setAttribute('data-page' , parseInt(loadedPage) + 1);
              const loadedPageAfterLoad = parseInt(document.querySelector('product-grid').getAttribute('data-page'));
              const gridBannersAfterLoad = document.querySelectorAll('.collection-grid-banner');
              const dataLayout = $('.product-grid-selector').hasClass('grid-cols--1')

              if(dataLayout){
                  if($(window).width() < 991){
                      $('.collapse.product-card__stack').addClass('collapse--active');
                      $('.collapse__body.product-card__stack__body').show();
                  }
                }
              if(window.innerWidth < 992){
                
                gridBannersAfterLoad.forEach(banner => {
                  let rowMobAfterLoad = parseInt(banner.getAttribute('data-mobile-row'));
                  if(loadedPageAfterLoad === 2){
                    if(rowMobAfterLoad > 8){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 3){
                    if(rowMobAfterLoad > 12){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 4){
                    if(rowMobAfterLoad > 16){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 5){
                    if(rowMobAfterLoad > 20){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 6){
                    if(rowMobAfterLoad > 24){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 7){
                    if(rowMobAfterLoad > 28){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                })
              } else {
                gridBannersAfterLoad.forEach(banner => {
                  let rowDeskAfterLoad = parseInt(banner.getAttribute('data-row'));
                  if(loadedPageAfterLoad === 2){
                    if(rowDeskAfterLoad > 4){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 3){
                    if(rowDeskAfterLoad > 6){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 4){
                    if(rowDeskAfterLoad > 8){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 5){
                    if(rowDeskAfterLoad > 10){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 6){
                    if(rowDeskAfterLoad > 12){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                  if(loadedPageAfterLoad === 7){
                    if(rowDeskAfterLoad > 14){
                      banner.classList.add('hide')
                    } else {
                      banner.classList.remove('hide')
                    }
                  }
                })
              }
            
                const productCardColumnElement = document.querySelector('.product-card ');

                // Get the other element
                const gridBannerElements = document.querySelectorAll('.collection-grid-banner');

                // Set the height of the other element to the height of the `.product-card__column` element
                function setHeight() {
                    if (gridBannerElements.length !== 0) {

                        gridBannerElements.forEach((element) => {
                            if (window.innerWidth < 991) {
                                element.style.height = productCardColumnElement.offsetHeight + 'px'
                            } else {
                                element.style.height = productCardColumnElement.offsetHeight - 3 + 'px'
                            }
                        })
                    }


                }

                // Set the height of the other element on window load
                setHeight()

                // Set the height of the other element on window resize
                window.addEventListener('resize', setHeight);
                const cards = document.querySelectorAll('.product-card');
                const columns = document.querySelectorAll('.product-card__column');
                cards.forEach((card) => new ProductCard(card))
                var currentUrl = window.location.href;

                  // Check if the URL has parameters
                  if (currentUrl.indexOf('?') !== -1) {
                   
                    columns.forEach(card => {
                      setTimeout(() => {
                        // if (card.querySelector('.product-card[handle]')) {
                        //   // Remove the column
                        //   card.remove();
                        // }
                        // Select all .baslide__item elements
                        const items = card.querySelectorAll('.baslide__item');
             
                        // Filter out items that contain an element with the class .product-card__swatch
                        const count = Array.from(items).filter(item => item.querySelector('.product-card__swatch')).length;
                    
                        console.log(count, card.querySelector('.product-card'));
                    
                        // Perform actions based on the count
                        if (count < 1) {
                          card.remove();
                        }
                        if (count < 6) {
                          card.classList.add('hide-arrows');
                        }
                        },400)
                    })
                    setTimeout(() => {
                      $('.product-card__column').css('opacity' ,'1');
                    },500)
                  } else {
                    
                  }
               
                
            },
        })
    }
}